<template>
	<div class="container_head ">
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="list">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				<div class="card" v-for="item in list" >
					<div class="left">
						<img :src="item.webUrl||defaultimg" alt="">
					</div>
					<div class="right">
						<div class="title">{{item.partyBranchMemberName}}</div>
						<!-- <div class="desc">党龄:{{item.dl}}</div> -->
						<div class="desc">年龄:{{item.age}}</div>
						<div class="desc">入党日期：{{item.joinDate.slice(0,10)}}</div>
						<div class="desc yh">楼宇信息：{{item.loudong}}-{{item.danyuan}}-{{item.louceng}}-{{item.mengpai}}</div>
						<div class="desc yh">联系电话：{{item.phone}}</div>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		List
	} from 'vant';
	Vue.use(List);
	export default {
		data() {
			return {
				list: [],
				loading: false,
				finished: false,
				refreshing: false,
				pageNum:0,
				defaultimg:require('../../assets/person1.png'),
				partyBranchId:''
			};
		},
		computed: {},
		mounted() {
			this.partyBranchId=this.$route.query.id;
		},
		methods: {
			onRefresh() {
				this.finished = false;
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true;
				this.onLoad();
			},
			onLoad() {
				if (this.refreshing) {
					this.pageNum=0;
					// 清空列表数据
					this.list = [];
					this.refreshing = false;
				}
				this.requestdata('/api/v1/wygl/partybranchmember/view')
			},
			requestdata(url){
				this.$axios.get(url, {
					params: {
						pageNum:this.pageNum,
						pageSize:15,
						partyBranchId:this.partyBranchId
					}
				}).then(res => {
					this.list.push(...res.data);
					this.pageNum++;
					this.loading = false;
					if (this.list.length >= res.total) {
						this.finished = true;
					}
				});
			},
			changeview(path) {
				this.$router.push(path);
			}
		}
	};
</script>

<style lang="less" scoped>
.flexcenter {
	display: flex;
	justify-content: center;
	align-items: center;
}
.list{
	padding: 10px;
}
.card{
	padding: 6px;
	background-color: #fff;
	border: 1px dashed #0eb6f5;
	overflow: hidden;
	width: 99%;
	margin: 1%;
	border-radius: 10px;
	display: flex;
	align-items: center;
	.left{
		float: left;
		img{
			width: 65px;
			height: 85px;
			object-fit: cover;
		}
	}
	.right{
		margin-left: 15px;
		.title{
			font-size: 16px;
			margin-bottom: 5px;
			text-align: center;
		}
		.desc{
			color: #aaa;
			font-size: 13px;
			text-align: left;
			padding: 1px 0;
		}
	}
}
</style>
